import React from "react";
import Header from "./components/header/Header";
import Nav from "./components/nav/Nav";
import About from "./components/about/About";
import Experiences from "./components/experiences/Experiences";
import Portfolio from "./components/portfolio/Portfolio";
// import Contact from "./components/contact/Contact";
import MessageForm from "./components/contact/MessageForm";
import Footer from "./components/footer/Footer";

const App = () => {
  return (
    <>
      <Header />
      <Nav />
      <About />
      <Experiences />
      <Portfolio />
      {/* <Contact /> */}
      <MessageForm />
      <Footer />
    </>
  );
};

export default App;
